const values = [
  {
    icon: "ri-user-heart-line",
    title: "Strength-Based",
    description: "I believe every client already has the inner resources to grow. My role is to help you identify and build on those strengths — not focus on what's broken.",
  },
  {
    icon: "ri-focus-3-line",
    title: "Person-Centered",
    description: "You are in control of your experience and your outcomes. The client sets the goals, the pace, and the direction. I follow your lead.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Safe & Accepting",
    description: "I strive for a sense of comfort and trust between clinician and client. This is a space free from judgment where you can show up exactly as you are.",
  },
  {
    icon: "ri-seedling-line",
    title: "Solution-Focused",
    description: "We keep an eye on where you want to go. Together we identify obtainable goals and work toward them with clarity and intention.",
  },
  {
    icon: "ri-heart-2-line",
    title: "Self-Care & Motivation",
    description: "Clients can expect to take away a stronger sense of self-care and motivation throughout treatment — tools that last well beyond our sessions.",
  },
  {
    icon: "ri-group-line",
    title: "Broad Experience",
    description: "From certified teaching to foster care, veterans, and couples — my diverse background means I bring real-world understanding to every session.",
  },
];

export default function PhilosophySection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#9a9a9a] text-xs font-medium tracking-widest uppercase mb-3">How I Work</p>
          <h2 className="text-3xl md:text-4xl font-light text-[#2d2d2d] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            My Philosophy of Care
          </h2>
          <p className="text-[#6b6b6b] text-sm leading-relaxed max-w-xl mx-auto">
            Therapy works best when the client feels in control, heard, and genuinely supported. Here's what you can always expect from working with me.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((value) => (
            <div key={value.title} className="bg-[#f0f9f9] rounded-2xl p-7 border border-[#d0ecea] hover:-translate-y-0.5 transition-transform duration-200">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#e6f6f5] mb-5">
                <i className={`${value.icon} text-[#4db8b1] text-xl`}></i>
              </div>
              <h3 className="text-[#2d2d2d] font-semibold text-base mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                {value.title}
              </h3>
              <p className="text-[#6b6b6b] text-sm leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
